import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { DoubleChevronLeft } from "@air/next-icons";
import noop from "lodash/noop";
import { memo } from "react";
import { usePublicWorkspace } from "~/components/PublicWorkspaceProvider";
import { PUBLIC_WORKSPACE_NAVIGATION, PUBLIC_WORKSPACE_NAVIGATION_BUTTON } from "~/constants/testIDs";
export const PublicWorkspaceNavigation = /*#__PURE__*/ memo((param)=>{
    let { onWorkspaceNavigate = noop } = param;
    const { workspaceName } = usePublicWorkspace();
    return /*#__PURE__*/ _jsx("div", {
        className: "flex items-center",
        "data-testid": PUBLIC_WORKSPACE_NAVIGATION,
        children: /*#__PURE__*/ _jsxs("button", {
            className: "flex cursor-pointer items-center border-none bg-transparent p-0 text-16 font-medium text-grey-10 hover:underline",
            "data-testid": PUBLIC_WORKSPACE_NAVIGATION_BUTTON,
            onClick: onWorkspaceNavigate,
            children: [
                /*#__PURE__*/ _jsx(DoubleChevronLeft, {
                    className: "mr-2 inline-block size-4"
                }),
                /*#__PURE__*/ _jsxs("div", {
                    className: "truncate text-16 text-inherit",
                    children: [
                        "View in\xa0",
                        workspaceName
                    ]
                })
            ]
        })
    });
});
PublicWorkspaceNavigation.displayName = "PublicWorkspaceNavigation";
